import { render, staticRenderFns } from "./VideoMcpViewer.vue?vue&type=template&id=6981b6f8&"
import script from "./VideoMcpViewer.vue?vue&type=script&lang=js&"
export * from "./VideoMcpViewer.vue?vue&type=script&lang=js&"
import style0 from "./VideoMcpViewer.vue?vue&type=style&index=0&id=6981b6f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports